import React, {useState} from 'react';
import PropTypes from 'prop-types';

const MobileMenuDropDown = ({options}) => {
    MobileMenuDropDown.propTypes = {
        options: PropTypes.array.isRequired,
    };
    const [isOpen, setIsOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(options[0]);


    const handleChange = (value) => {
        setSelectedValue(value);
        setIsOpen(false);
    };

    return (
        <div className="dropdownContainer">
            <div
                role="button"
                tabIndex="0"
                className="dropdownButton"
                onClick={() => setIsOpen(!isOpen)}
            >
                {selectedValue}
                <img
                    src="../assets/icons/DownArrow.svg"
                    className={`dropdownArrowMenu ${isOpen ? 'open' : ''}`}
                    alt="Arrow"
                />
            </div>
            {isOpen && (
                <div className="dropdownOptions">
                    {options.map((option) => (
                        <div
                            role="button"
                            tabIndex="0"
                            className="dropdownOption"
                            key={option}
                            onClick={() => handleChange(option)}
                        >
                            {option}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MobileMenuDropDown;
